import { CostChannel } from '@sg/graphql-schema';

import { useGetSharedLineItemProductForRestaurantQuery } from '../../GraphQL/ShareLineItemScreen.generated';
import { useShareLineItemLocationDetails } from '../useShareLineItemLocationDetails';

// ─────────────────────────────────────────────────────────────────────────────

export const useShareLineItemRemoteData = (params: Params) => {
  const { baseProductSlug, selectedDeliveryAddressId, selectedRestaurantId } = params;

  const costChannel = selectedDeliveryAddressId
    ? CostChannel.DeliveryCostChannel
    : CostChannel.DefaultCostChannel;

  // ─── Remote Data ─────────────────────────────────────────────────────

  const locationDetails = useShareLineItemLocationDetails({
    restaurantId: selectedRestaurantId,
    deliveryAddressId: selectedDeliveryAddressId,
  });

  const [productResponse] = useGetSharedLineItemProductForRestaurantQuery({
    pause: !baseProductSlug || !selectedRestaurantId,
    requestPolicy: 'network-only',
    variables: {
      baseProductSlug: baseProductSlug ?? '',
      restaurantId: selectedRestaurantId ?? '',
      costChannel,
    },
  });

  // ─── Derived ─────────────────────────────────────────────────────────

  const isFetchingSharedLinkProduct = productResponse.fetching || locationDetails.isFetching;

  const productForRestaurant = productResponse.data?.productForRestaurant ?? undefined;
  const hasNoProductData = !productResponse.fetching && !productForRestaurant;
  const isUnavailableProduct = hasNoProductData || productForRestaurant?.outOfStock === true;

  // ─────────────────────────────────────────────────────────────────────

  return {
    isFetchingSharedLinkProduct,
    isUnavailableProduct,
    locationDetails,
    productForRestaurant,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  baseProductSlug?: string;
  selectedDeliveryAddressId?: string;
  selectedRestaurantId?: string;
};
